export default {"src":"/stays/_next/static/media/OverallRating.3d5bd707.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};